import React from "react";
import WithSection from "components/ScreenSection/WithSection";
import NationalTransportForm from "../component/NationalTransport";
import NTSideDetails from "../component/shared/NTSideRecap";

export function NationalTransport() {
  return (
      <WithSection leftComponent={<NationalTransportForm />} rightComponent={<NTSideDetails />} />
  );
}
